/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ShopifyAppControllerDeleteSessions$Params {

/**
 * Comma-separated Shopify session ids
 */
  ids?: Array<string>;

/**
 * Shop domain, e.g. my-shop.myshopify.com
 */
  shop?: string;

/**
 * Store identifier for multi-tenant requests.
 */
  'terrific-store-id'?: string;
}

export function shopifyAppControllerDeleteSessions(http: HttpClient, rootUrl: string, params?: ShopifyAppControllerDeleteSessions$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, shopifyAppControllerDeleteSessions.PATH, 'delete');
  if (params) {
    rb.query('ids', params.ids, {});
    rb.query('shop', params.shop, {});
    rb.header('terrific-store-id', params['terrific-store-id'], {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

shopifyAppControllerDeleteSessions.PATH = '/api/v1/shopify-app/sessions';
